module.exports = require("@village/icons");;